var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1184 33.9506C7.41769 31.7612 4.13472 26.993 4.12308 21.4838C4.10738 14.0623 9.96034 8.00475 17.3012 7.69194C17.6257 7.67811 17.8978 7.9339 17.8978 8.25866V21.219C17.8978 21.3694 17.9575 21.5137 18.0639 21.6201L27.2279 30.7841C27.4571 31.0133 27.447 31.3867 27.2081 31.6058C24.7736 33.8397 21.5335 35.2095 17.9727 35.2285C16.8618 35.2344 15.7799 35.1072 14.7423 34.8617",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0163 14.5758C34.337 15.6472 34.5309 16.7735 34.5805 17.9371C34.5943 18.2614 34.3382 18.5331 34.0136 18.5331H20.8184V5.33791C20.8184 5.0133 21.0902 4.75729 21.4145 4.77104C26.425 4.98432 30.7425 7.87408 32.9738 12.0472",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1891 21.8364C36.0933 25.3525 34.6801 28.5388 32.4258 30.9207C32.2821 31.0725 32.0412 31.0757 31.8935 30.9279L23.0528 22.0873C22.8191 21.8536 22.9845 21.4541 23.315 21.4541H35.8178C36.027 21.4541 36.1948 21.6273 36.1891 21.8364Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7031 12.3153L33.283 5.73535H38.1843",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1845 8.42969H36.1943",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6992 24.7803L35.9179 31.0098H39.4136",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4141 33.5059H37.3701",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3503 13.7421L5.68531 9.07715H0.585938",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 11.6455H2.44031",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureDetails);
export default __webpack_public_path__ + "static/media/measureDetails.041e8bd9e37594b00dc1d0dfe8e975b4.svg";
export { ForwardRef as ReactComponent };